import { connect } from "react-redux";
import { Action, Dispatch } from "redux";

import { applicantInvitationAction } from "../../../actions";
import { RootState } from "../../../reducers";
import ExamEntrance from "./ExamEntrance";

const mapStateToProps = (state: RootState) => ({
  pageLanguage: state.intl.locale,
  loading: Boolean(state.ajax.submitting),
  initial: state.applicant.initialShared,
  error: state.applicant.error,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  sendInvitation: (payload: {}) => {
    dispatch(applicantInvitationAction.request(payload));
  },
});

/**
 * Wrapped component
 */
const wrappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExamEntrance);

export default wrappedComponent;
